var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2Month(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    fill: "#E365B1",
    fillOpacity: 0.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    stroke: "#E365B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.001 11.5C25.7722 11.5 27.6578 11.5 28.8294 12.7448C30.001 13.9896 30.001 15.9931 30.001 20C30.001 24.0069 30.001 26.0104 28.8294 27.2552C27.6578 28.5 25.7722 28.5 22.001 28.5L18.001 28.5C14.2297 28.5 12.3441 28.5 11.1725 27.2552C10.001 26.0104 10.001 24.0069 10.001 20C10.001 15.9931 10.001 13.9896 11.1726 12.7448C12.3441 11.5 14.2297 11.5 18.001 11.5L22.001 11.5Z",
    stroke: "#E365B1",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.369 23.42V24.5H12.125V23.804L14.657 21.068C15.617 20.024 15.989 19.46 15.989 18.728C15.989 17.924 15.425 17.36 14.597 17.36C13.697 17.36 13.097 17.948 13.097 18.848H11.909C11.909 17.348 13.037 16.268 14.645 16.268C16.157 16.268 17.261 17.252 17.261 18.584C17.261 19.508 16.913 20.156 15.581 21.572L13.949 23.42H17.369ZM19.7114 24.5H18.4994V18.14H19.6274V19.196C20.0594 18.464 20.7434 18.02 21.6194 18.02C22.5554 18.02 23.2634 18.5 23.5514 19.34C23.9954 18.524 24.7274 18.02 25.6994 18.02C27.0074 18.02 27.8474 18.872 27.8474 20.384V24.5H26.6354V20.768C26.6354 19.712 26.1674 19.088 25.2794 19.088C24.4514 19.088 23.7794 19.784 23.7794 20.852V24.5H22.5674V20.768C22.5674 19.712 22.0994 19.088 21.2114 19.088C20.3714 19.088 19.7114 19.784 19.7114 20.852V24.5Z",
    fill: "#E365B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Month);
export default __webpack_public_path__ + "static/media/2month.c46c4ad81c55dc243d3941a2babfeb7e.svg";
export { ForwardRef as ReactComponent };